import { ReactNode, useCallback } from 'react'
import { createPortal } from 'react-dom'
import Styles from './TopBar.module.scss'
import { Text } from 'blaze-ui/Text/Text'

export const SCHEDULED_POST_MOBILE_TOP_BAR = 'scheduled-post-mobile-top-bar'

interface Props {
  title?: string
  icon?: ReactNode
  leftContent?: ReactNode
  rightContent?: ReactNode
}

export const TopBar = ({ title, icon, leftContent, rightContent }: Props) => {
  const portalContainer = document.getElementById(SCHEDULED_POST_MOBILE_TOP_BAR)
  const topBar = useCallback(
    () =>
      portalContainer &&
      createPortal(
        <div className={Styles.topBar}>
          <div className={Styles.leftContent}>{leftContent}</div>
          <div className={Styles.title}>
            {icon}
            <Text>{title}</Text>
          </div>
          <div className={Styles.rightContent}>{rightContent}</div>
        </div>,
        portalContainer,
      ),
    [icon, leftContent, portalContainer, rightContent, title],
  )

  return <>{topBar()}</>
}
